<template>
    <b-card v-shortkey="{focusOnCm: ['c']}" @shortkey="keyDown"
            border-variant="light-dark"
            header="Contactmomenten"
            header-bg-variant="light"
            header-text-variant="dark"
            class="mt-3 mb-3 timeline-box">

        <div v-if="lead.contact_moments && lead.contact_moments.length === 0">
            <div class="p-4">Geen contactmomenten gevonden.</div>
        </div>

        <ul v-else class="timeline">
            <li v-for="result in lead.contact_moments" :data-icon="result.contact_moment_category_id">
                <div class="d-flex justify-content-between">
                    <div class="title">
                        {{result.created_by.name}}:
                    </div>
                    <div class="time text-muted">
                        <i>{{ date(result.created_at) }} om {{moment(result.created_at).format('LT')}}</i>
                    </div>
                </div>
                <p>
                    {{result.content}}
                </p>
            </li>
        </ul>

        <template slot="footer">
            <div v-if="updateable">
                <ValidationObserver ref="observer" v-slot="{ invalid }">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="cm-type">Type: *</label>
                                <ValidationProvider rules="required" v-slot="{ valid, errors }">
                                    <ep-contact-moment-category-select :radioButtons="true" :state="errors[0] ? false : null" id="cm-type" v-model="form.type"></ep-contact-moment-category-select>
                                    <b-form-invalid-feedback id="inputLiveFeedback">{{ errors[0] }}</b-form-invalid-feedback>
                                </ValidationProvider>
                            </div>

                            <div class="form-group">
                                <label for="cm-content">Bericht: *</label>
                                <ValidationProvider rules="required" v-slot="{ valid, errors }">
                                    <b-form-textarea ref="cmcontent" id="cm-content" v-model="form.content" :state="errors[0] ? false : null" placeholder="Optioneel..." rows="2" max-rows="12"></b-form-textarea>
                                    <b-form-invalid-feedback id="inputLiveFeedback">{{ errors[0] }}</b-form-invalid-feedback>
                                </ValidationProvider>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between align-items-center ">
                        <div class="text-muted"></div>
                        <div class="text-right">
                            <b-form-checkbox class="cmChangeStatus mr-2" v-if="lead.status_id != settings.awaitingCustomerStatusId" v-model="cmChangeStatus">Wijzig status naar 'In afwachting'</b-form-checkbox>

                            <div class="btn-group" v-tooltip="invalid ? 'Controleer de velden, op dit moment zijn nog niet alle velden juist ingevoerd' : null">
                                <b-button variant="primary" :disabled="invalid" @click="add()">Toevoegen <em class="fa fa-arrow-alt-circle-right"></em></b-button>
                            </div>
                        </div>
                    </div>
                </ValidationObserver>
            </div>
        </template>
    </b-card>
</template>

<script>
    import EpContactMomentCategorySelect from "../input/epContactMomentCategorySelect";
    import { ValidationProvider, ValidationObserver } from "vee-validate";

    export default {
        components: {
            EpContactMomentCategorySelect,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            lead: {
                type: Object,
                required: false
            },
            updateable: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: {},
                cmChangeStatus: false,
                settings: {}
            }
        },
        computed: {

        },
        watch: {},
        mounted() {
            this.reset();
        },
        updated() {
            this.settings = this.$store.getters['settingsStore/settings'];
        },
        methods: {
            validate() {
                return true;
            },
            date(date) {
                let now = this.moment();
                let nowCheck = this.moment().startOf("day");
                let yest = this.moment().subtract(1, "day").startOf("day");
                let mom = this.moment(date).startOf("day");
                if(mom.isSame(now, 'day')) {
                    return 'vandaag';
                } else if(mom.isSame(yest, 'day')) {
                    return 'gisteren';
                }
                return mom.format('L');
            },
            add() {
                this.$swal.showLoading();

                this.$swal({
                    title: 'Bezig met toevoegen',
                    html: 'We versturen nu de data...',
                    allowOutsideClick: true,
                    onOpen: () => {
                        this.$swal.showLoading()
                    }
                });

                axios.post('/api/v1/leads/form/' + this.lead.id + '/contactmoment', this.form)
                    .then(response => {
                        if(this.cmChangeStatus) {
                            axios.put('/api/v1/leads/form/' + this.lead.id + '/update', { status_id: this.settings.awaitingCustomerStatusId })
                                .then(response => {
                                    let leadSaved = response.data;

                                    this.$swal({
                                        toast: true,
                                        position: 'top',
                                        type: 'success',
                                        title: 'Contactmoment toegevoegd en status gewijzigd!',
                                        showConfirmButton: false,
                                        timer: 2000,
                                        backdrop: false
                                    });

                                    this.$emit('updated', leadSaved);
                                    this.cmChangeStatus = false;
                                })
                                .catch(error => {
                                    this.$swal({
                                        type: 'error',
                                        showConfirmButton: false,
                                        html: this.$errorMessage(error)
                                    });
                                })
                        }else{
                            this.$swal({
                                toast: true,
                                position: 'top',
                                type: 'success',
                                title: 'Contactmoment is toegevoegd!',
                                showConfirmButton: false,
                                timer: 2000,
                                backdrop: false
                            });
                        }

                        let formSaved = response.data;
                        this.lead.contact_moments.push(formSaved);
                        this.form = {};
                        this.$refs.observer.reset();
                    })
                    .catch(error => {
                        this.$swal({
                            type: 'error',
                            showConfirmButton: false,
                            html: this.$errorMessage(error)
                        });
                    });
            },
            reset() {
                this.form = {
                    type: null,
                    content: ''
                };
            },
            keyDown(event) {
                switch (event.srcKey) {
                    case 'focusOnCm':
                        this.$refs.cmcontent.focus();
                    break;
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../sass/variables";

    .timeline-box .card-body {
        max-height: none;
        overflow-y: hidden;
    }

    ul.timeline .title {
        margin-top: 3px;
        line-height: 17px;
        font-weight: bold;
    }

    ul.timeline li::before {
        font-family: "Font Awesome 5 Pro", fantasy;
        color: $primary;
        font-size: 13px;
        line-height: 23px;
        padding-left: 5px;
        width: 26px;
        height: 26px;
        left: 17px;
		content: "\f075";
    }

    ul.timeline li[data-icon="0"]::before {
        content: "\f121";
		padding-left: 3px;
    }

    ul.timeline li[data-icon="1"]::before {
        content: "\f1fa";
    }

    ul.timeline li[data-icon="2"]::before {
        content: "\f095";
    }

    ul.timeline li[data-icon="3"]::before {
        content: "\f007";
    }

    .cmChangeStatus {
        display: inline-block;
    }
</style>